import { useEffect, useRef, useState } from "react";
import { MdContentCopy } from "react-icons/md";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { contractDetailsGAFunctions } from "../../GA/ContractDetails";
import FetchABI from "../../Hooks/GetABI";
import Tokens from "../../components/Tokens";
import { APIRoutes } from "../../constants/ApiRoutes";
import constantsValues from "../../constants/constantsValues";
import ApiCall from "../../helper/ApiCall";
import GetContractType from "../../helper/GetContractType";
import { CsvUploader } from "../../components/csvUpload";
import { ethers } from "ethers";

export default function ContractDetails() {
  const abiRef = useRef(null);
  // useState
  const [overview, setOverview] = useState(true);
  const [abi, SetABI] = useState("");
  const [whitelistUser, setWhitelistUser] = useState("");
  const [whitelistData, setWhitelistData] = useState("");
  const [loading, setLoading] = useState(false);
  // functions
  const location = useLocation();
  const navigate = useNavigate();
  const data = location?.state;
  //

  function validateEmail(email_id) {
    const regex_pattern =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (regex_pattern.test(email_id)) {
      return email_id;
    } else {
      return email_id.slice(0, 5) + "....." + email_id.slice(-5);
    }
  }

  async function getAbi() {
    if (data.isWhiteListUser) {
      fetchWhiteList();
    }
    let getABIvar;
    getABIvar = await FetchABI(data.contractType);
    SetABI(getABIvar);
  }
  // fetch whitelist user from db
  async function fetchWhiteList() {
    const { res, resData } = await ApiCall(`${APIRoutes.getWhiteListUser}${data?.contractAddress}`, "GET", null);
    if (res.ok) {
      if (resData.data.length > 0) {
        setWhitelistData(resData.data[0].whiteListUsers);
      }
    } else {
      console.error("Error in get whiteListUserAPI", resData);
    }
  }
  // add white list user to db
  async function addWhiteListUser() {
    if (!whitelistUser) {
      toast.error("Please Provide WhileList User Details");
      return;
    }

    if (!ethers.utils.isAddress(whitelistUser)) {
      toast.error("Please provide a valid whitelist address.");
      return;
    }

    setLoading(true);
    const { res, resData } = await ApiCall(APIRoutes.addWhiteListUser, "POST", {
      contractAddress: data.contractAddress,
      userAddress: whitelistUser.toLowerCase(),
      max: data.maxMintAllowedPerUser,
    });
    if (resData.status && res.ok) {
      toast.success(resData.message);
      setWhitelistData((prv) => [
        ...prv,
        {
          userAddress: whitelistUser.toLowerCase(),
          max: data.maxMintAllowedPerUser,
        },
      ]);
      setWhitelistUser("");
    } else {
      toast.error(resData.msg ? resData.msg : resData.message);
    }
    setLoading(false);
  }

  // useEffect
  useEffect(() => {
    if (data?.category === "collection") getAbi();
    if (data) {
      if (data.prv) {
        setOverview(false);
      }
    }
  }, []);

  if (!data) {
    return <Navigate to="/" />;
  }
  return (
    <>
      {/* Sub Header Start */}
      {/* show overview and tokens if data.category===oneOnone||multiple*/}
      {data.category === "oneOnone" || data.category === "multiple" ? (
        <div className="switch">
          <div>
            <li
              className={overview ? "active" : ""}
              onClick={() => {
                contractDetailsGAFunctions.overviewEvent();
                setOverview(!overview);
              }}
            >
              Overview
            </li>
            <li
              className={!overview ? "active" : ""}
              onClick={() => {
                contractDetailsGAFunctions.tokensEvent();
                setOverview(!overview);
              }}
            >
              Tokens
            </li>
          </div>
          {/* show create button to mint tokens in oneOnone and multiple */}
          {!overview ? (
            <div className="create-more">
              {data.category === "oneOnone" || data.category === "multiple" ? (
                <button
                  className="mint-btn"
                  onClick={() => {
                    contractDetailsGAFunctions.createNFTEvent();
                    navigate("/mint-tokens", {
                      state: {
                        contractAddress: data.contractAddress,
                        category: data.category,
                        data,
                      },
                    });
                  }}
                >
                  Create
                </button>
              ) : null}
            </div>
          ) : null}
        </div>
      ) : null}
      {/* Sub Header End */}

      {overview ? (
        // contract Details pages
        <>
          <div
            style={{ paddingInline: "0" }}
            className={`new-contract mintMain contract-details  ${
              data.category === "oneOnone" || data.category === "multiple" ? "marginExtra" : ""
            }`}
          >
            <main style={{ paddingBottom: "2rem" }} className="main-content">
              <article style={{ paddingTop: "2rem" }} className="content">
                <h1 className="content-heading">Smart Contract Details</h1>
                <p className="content-description">
                  Your contract name is a key identifier that appears wherever your contract is mentioned or listed.
                  Typically, it reflects your artist name, collection name, brand, or project name.
                </p>
                <small className="deployed-date text-dull">
                  Contract Deployed on: {data.contractCreatedAt.toString().substring(0, 10)}
                </small>

                {data?.contractType === "biconomy" || data?.contractType === "biconomy1155" ? (
                  <div className="fill-gas-wrapper">
                    <a
                      href="https://dashboard-gasless.biconomy.io/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="fill-gas"
                    >
                      Fill Gas
                    </a>
                  </div>
                ) : null}
                <div className="content-btns">
                  <a href={constantsValues[data?.chainId]?.blockExplorer + data.contractAddress} target="_blank">
                    {" "}
                    <button
                      className="deploy-btn"
                      style={{ marginRight: "10px" }}
                      onClick={() => {
                        contractDetailsGAFunctions.viewOnBlockExplorerEvent();
                      }}
                      // onClick={() => DeployContract()}
                      // disabled={isLoading || !address}
                    >
                      View on Block Explorer
                    </button>
                  </a>

                  {data.category === "collection" ? (
                    // open mint(claimer) page if data.category === "collection"
                    <Link to={`/mint/${data.networkType}/${data.contractAddress}`} target="_blank">
                      {" "}
                      <button
                        className="deploy-btn"
                        style={{ marginRight: "10px" }}
                        onClick={() => {
                          contractDetailsGAFunctions.openMintPageEvent();
                        }}
                      >
                        Open Mint Page
                      </button>
                    </Link>
                  ) : null}
                  {data.category === "frame" ? (
                    // open mint(claimer) page if data.category === "collection"
                    <Link to={`/https://warpcast.com/`} target="_blank">
                      {" "}
                      <button
                        className="deploy-btn"
                        style={{ marginRight: "10px" }}
                        onClick={() => {
                          contractDetailsGAFunctions.castFrameEvent();
                        }}
                      >
                        Cast Frame
                      </button>
                    </Link>
                  ) : null}
                </div>
                <div className="line"></div>
                <div className="collectionBtns">
                  {constantsValues[data.chainId]?.openSeaCollection ||
                  constantsValues[data.chainId]?.raribleCollection ? (
                    <p>Check Your Collection:</p>
                  ) : null}
                  <div className="collectionBtns-logo">
                    {constantsValues[data.chainId]?.openSeaCollection ? (
                      <a
                        href={`${constantsValues[data.chainId]?.openSeaCollection}${data.contractAddress}`}
                        target={"/blank"}
                      >
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M11.5 0C5.15008 0 0 5.15008 0 11.5C0 17.8499 5.15008 23 11.5 23C17.8499 23 23 17.8499 23 11.5C23 5.15008 17.8528 0 11.5 0ZM5.67333 11.8862L5.72221 11.8086L8.71508 7.12808C8.72511 7.1127 8.73908 7.10029 8.75554 7.09214C8.772 7.084 8.79034 7.08043 8.80865 7.0818C8.82697 7.08317 8.84457 7.08944 8.85964 7.09994C8.8747 7.11044 8.88667 7.12479 8.89429 7.1415C9.39262 8.26179 9.82579 9.65521 9.62263 10.5225C9.53829 10.879 9.30158 11.362 9.03421 11.8086C8.99991 11.8739 8.96249 11.9376 8.92208 11.9993C8.91241 12.0131 8.89946 12.0242 8.8844 12.0317C8.86935 12.0393 8.85266 12.0429 8.83583 12.0424H5.76246C5.74411 12.0427 5.72604 12.038 5.71014 12.0288C5.69425 12.0197 5.68113 12.0064 5.67219 11.9904C5.66325 11.9743 5.65881 11.9562 5.65935 11.9379C5.65989 11.9195 5.66538 11.9017 5.67525 11.8862H5.67333ZM19.0076 13.4962C19.0078 13.5167 19.002 13.5368 18.991 13.554C18.9799 13.5712 18.964 13.5847 18.9453 13.593C18.7124 13.6917 17.9199 14.0578 17.5902 14.5149C16.7488 15.686 16.1067 17.3612 14.6692 17.3612H8.67579C8.16976 17.3604 7.66883 17.2599 7.20164 17.0655C6.73445 16.8711 6.31016 16.5865 5.95301 16.228C5.59585 15.8695 5.31284 15.4442 5.12015 14.9762C4.92746 14.5083 4.82887 14.007 4.83 13.501V13.432C4.83 13.3764 4.876 13.3304 4.9335 13.3304H8.27329C8.34037 13.3304 8.38829 13.3908 8.3835 13.4569C8.35858 13.6735 8.39979 13.8968 8.50329 14.099C8.70071 14.5015 9.11279 14.7526 9.5565 14.7526H11.2106V13.4617H9.57375C9.55457 13.4615 9.53581 13.4561 9.51949 13.446C9.50317 13.4359 9.4899 13.4216 9.48113 13.4045C9.47235 13.3875 9.4684 13.3683 9.46969 13.3492C9.47098 13.3301 9.47747 13.3116 9.48846 13.2959L9.54883 13.2097C9.70217 12.9883 9.92354 12.6481 10.144 12.259C10.2935 11.9964 10.4391 11.7166 10.556 11.4348C10.579 11.385 10.5972 11.3323 10.6183 11.2815C10.65 11.1914 10.6825 11.1071 10.7055 11.0237C10.7281 10.953 10.7489 10.8818 10.7678 10.81C10.8225 10.5704 10.8455 10.3174 10.8455 10.0558C10.8455 9.95229 10.8416 9.844 10.832 9.74242C10.8273 9.63029 10.8129 9.51721 10.7995 9.40508C10.7887 9.30476 10.7734 9.20499 10.7535 9.10608C10.7277 8.95548 10.6963 8.80588 10.6595 8.65758L10.6461 8.60008C10.6174 8.49658 10.5925 8.39883 10.5599 8.29629C10.4686 7.98139 10.3637 7.6706 10.2455 7.36479C10.2044 7.24976 10.159 7.13628 10.1095 7.02458C10.0405 6.854 9.96954 6.69971 9.90533 6.555C9.87339 6.493 9.84334 6.43004 9.81525 6.36621C9.78408 6.29734 9.75117 6.22928 9.71654 6.16208C9.69354 6.11129 9.66575 6.06242 9.64754 6.01642L9.44533 5.64458C9.41754 5.59379 9.46354 5.5315 9.51912 5.54779L10.7841 5.88992H10.7937L10.9595 5.93783L11.1435 5.98958L11.2106 6.00779V5.25742C11.2106 4.89421 11.5 4.6 11.8613 4.6C11.9466 4.59977 12.0311 4.6168 12.1096 4.65007C12.1882 4.68334 12.2592 4.73215 12.3184 4.79358C12.4408 4.917 12.5096 5.08363 12.5101 5.25742V6.37292L12.6452 6.41029C12.6548 6.41508 12.6663 6.41987 12.6749 6.42658C12.7075 6.44958 12.7554 6.486 12.8158 6.532C12.8637 6.56842 12.9145 6.61442 12.9739 6.66329C13.1632 6.81747 13.3466 6.97858 13.524 7.14629C13.7291 7.337 13.9591 7.56029 14.1795 7.8085C14.2418 7.87942 14.3012 7.94842 14.3635 8.02508C14.4229 8.10079 14.49 8.17458 14.5456 8.24742C14.6213 8.34708 14.6989 8.45058 14.7708 8.55792C14.8024 8.60871 14.8417 8.66142 14.8714 8.71221C14.9634 8.84829 15.042 8.98821 15.1177 9.12908C15.1503 9.19329 15.1819 9.26421 15.2097 9.33321C15.295 9.522 15.3621 9.71271 15.4033 9.90629C15.4169 9.94738 15.4262 9.98977 15.4311 10.0328V10.0424C15.4445 10.097 15.4493 10.1574 15.4541 10.2187C15.4811 10.502 15.4464 10.7877 15.3525 11.0563C15.3228 11.1368 15.295 11.2192 15.2586 11.2997C15.1867 11.4626 15.1043 11.6284 15.0056 11.7808C14.973 11.8383 14.9337 11.8977 14.8973 11.9552C14.8561 12.0156 14.812 12.0731 14.7756 12.1277C14.7229 12.2003 14.6676 12.2709 14.6098 12.3395C14.559 12.4085 14.5082 12.4775 14.4507 12.5398C14.3731 12.6337 14.2974 12.7219 14.2159 12.8062C14.1699 12.8618 14.1201 12.9193 14.0664 12.9691C14.0166 13.0266 13.9629 13.0774 13.9169 13.1234C13.8364 13.2039 13.7732 13.2643 13.7176 13.317L13.5863 13.4339C13.568 13.4523 13.5432 13.4626 13.5173 13.4627H12.5101V14.7526H13.777C14.0597 14.7526 14.329 14.6529 14.5475 14.467C14.6213 14.4028 14.9452 14.122 15.3295 13.6984C15.342 13.684 15.3588 13.6739 15.3774 13.6697L18.8753 12.6567C18.8907 12.6523 18.9069 12.6514 18.9226 12.6543C18.9383 12.6572 18.9532 12.6636 18.966 12.6732C18.9788 12.6828 18.9892 12.6952 18.9964 12.7094C19.0037 12.7237 19.0075 12.7394 19.0076 12.7554V13.4962Z"
                            fill="white"
                          />
                        </svg>
                      </a>
                    ) : null}
                    {constantsValues[data.chainId]?.raribleCollection ? (
                      <a
                        href={`${constantsValues[data.chainId]?.raribleCollection}${data.contractAddress}/items`}
                        target={"/blank"}
                      >
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M4.60001 1.00253e-05C3.99557 -0.00125317 3.39684 0.116867 2.83817 0.347591C2.2795 0.578316 1.7719 0.917101 1.3445 1.3445C0.917101 1.7719 0.578316 2.2795 0.347591 2.83817C0.116867 3.39684 -0.00125317 3.99557 1.00253e-05 4.60001V18.4C-0.00125317 19.0044 0.116867 19.6032 0.347591 20.1618C0.578316 20.7205 0.917101 21.2281 1.3445 21.6555C1.7719 22.0829 2.2795 22.4217 2.83817 22.6524C3.39684 22.8832 3.99557 23.0013 4.60001 23H18.4C19.0044 23.0013 19.6032 22.8832 20.1618 22.6524C20.7205 22.4217 21.2281 22.0829 21.6555 21.6555C22.0829 21.2281 22.4217 20.7205 22.6524 20.1618C22.8832 19.6032 23.0013 19.0044 23 18.4V4.60001C23.0013 3.99557 22.8832 3.39684 22.6524 2.83817C22.4217 2.2795 22.0829 1.7719 21.6555 1.3445C21.2281 0.917101 20.7205 0.578316 20.1618 0.347591C19.6032 0.116867 19.0044 -0.00125317 18.4 1.00253e-05H4.60001ZM5.86501 7.36001H13.7253C15.6994 7.36001 17.2385 7.78168 17.2385 9.59676C17.2385 10.6864 16.5955 11.2278 15.871 11.4157C16.7373 11.6725 17.364 12.374 17.364 13.4857V15.5279H14.0568V13.5892C14.0568 12.995 13.7023 12.7554 13.0985 12.7554H9.17318V15.5279H5.86501V7.36001ZM9.17318 9.75584V10.5551H13.1551C13.5882 10.5551 13.8508 10.4976 13.8508 10.1564C13.8508 9.81334 13.5882 9.75584 13.1551 9.75584H9.17318Z"
                            fill="white"
                          />
                        </svg>
                      </a>
                    ) : null}
                  </div>
                </div>

                {whitelistData.length > 0 ? (
                  <div className="details">
                    <div className="details_head">
                      <p>User Addresses</p>

                      <div className="line"></div>
                    </div>
                    {whitelistData.map((data, id) => (
                      <li>
                        <span className="whitelist-userAdd">{validateEmail(data.userAddress)}</span>
                        {data.start && data.max ? (
                          <p className="check">{`${data.start}/${data.max} NFT Claim`}</p>
                        ) : (
                          <p className="check">0/{data.max} NFT Claim</p>
                        )}
                      </li>
                    ))}
                  </div>
                ) : null}

                {data.category === "collection" && data.isWhiteListUser ? (
                  <div className="whitelis-main-container">
                    <CsvUploader contractAddress={data.contractAddress} />
                    <p className="whitelist-input-divider">OR</p>
                    <div className="whitelist-input-container">
                      <input
                        type="text"
                        placeholder="Whitelist User"
                        className="whitelist-input"
                        value={whitelistUser}
                        onChange={(e) => setWhitelistUser(e.target.value)}
                      />
                      <button
                        className="add-whitelist-btn"
                        onClick={() => {
                          contractDetailsGAFunctions.addWhitelistEvent();
                          addWhiteListUser();
                        }}
                        disabled={loading}
                      >
                        Add Whitelist User
                      </button>
                    </div>
                  </div>
                ) : null}
              </article>

              {/* Right Section Contract Details  */}
              <div className="contract-information">
                {data?.isFrameMinting && (
                  <div className="information-group">
                    <div className="copyAddress">
                      <label className="label">Farcaster Link</label>
                      <button
                        onClick={() => {
                          navigator.clipboard.writeText(
                            `${process.env.REACT_APP_SERVER_URL}frames/${data.chainId}/${data.contractAddress}`
                          );
                          toast.success("Framecast link Copied to Clipboard.");
                        }}
                        className="copyBtn"
                      >
                        <MdContentCopy />
                      </button>
                    </div>

                    <p className="name contract-address">
                      {`${process.env.REACT_APP_SERVER_URL}
                      `}
                      <br />
                      {`frames/${data.chainId}/${data.contractAddress}`}
                    </p>
                  </div>
                )}

                <div className="information-group">
                  <div className="copyAddress">
                    <label className="label">Contract Address</label>
                    <button
                      onClick={() => {
                        navigator.clipboard.writeText(data.contractAddress);
                        toast.success("Contract Address Copied to Clipboard.");
                      }}
                      className="copyBtn"
                    >
                      <MdContentCopy />
                    </button>
                  </div>

                  <p className="name contract-address">{data.contractAddress}</p>
                </div>
                <div className="information-group">
                  <label className="label">Contract Name</label>
                  <input
                    style={{ textTransform: "uppercase" }}
                    className="name"
                    type="text"
                    name="name"
                    id="name"
                    value={data.contractName}
                  />
                </div>
                <div className="information-group">
                  <label className="label">Contract Symbol</label>
                  <p style={{ textTransform: "uppercase" }} className="name">
                    {data.symbol}
                  </p>
                </div>
                <div className="information-group">
                  <label className="label">Deployed Chain</label>
                  <p style={{ textTransform: "uppercase" }} className="name">
                    {data.networkType}
                  </p>
                </div>
                <div className="information-group-container">
                  <div className="information-group">
                    <label className="label">Type</label>
                    <p
                      style={{
                        textTransform: "uppercase",
                      }}
                      className="name"
                    >
                      {GetContractType(data.contractType)}
                    </p>
                  </div>
                  <div className="information-group">
                    <label className="label">Category</label>
                    <p
                      style={{
                        textTransform: "uppercase",
                      }}
                      className="name"
                    >
                      {data.category}
                    </p>
                  </div>
                </div>
                {abi ? (
                  <div className="information-group abi-string-group">
                    <div className="abi-label-container">
                      <label className="label">Contract ABI</label>
                      <button
                        onClick={() => {
                          navigator.clipboard.writeText(JSON.stringify(abi));
                          toast.success("ABI Copied to Clipboard.");
                        }}
                        className="copyBtn abiCopyBtn"
                      >
                        <MdContentCopy />
                      </button>
                    </div>
                    <textarea rows={6} className="abi-string" ref={abiRef}>
                      {JSON.stringify(abi)}
                    </textarea>
                  </div>
                ) : null}
              </div>
            </main>
          </div>
        </>
      ) : (
        // Tokens page
        <Tokens data={data} />
      )}
    </>
  );
}
